import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export const useScroll = (scrollbarClass: 'scrollbar' | string): ((options: ScrollToOptions) => void) => {
  const pathname = useLocation().pathname;
  const [scrollBar, setScrollBar] = useState<Element | null>(null);

  useEffect(() => {
    setScrollBar(document.querySelector(`.${scrollbarClass} > div`));
  }, [pathname, scrollbarClass]);

  const scrollTo = useCallback(
    (options: ScrollToOptions) => {
      const element = scrollBar || document.querySelector(`.${scrollbarClass} > div`);
      element?.scrollTo({ ...options });
    },
    [scrollBar, scrollbarClass]
  );

  return scrollTo;
};
